import React from 'react';

import {getSampleControlRolesColumns} from 'bulk-import/storables/StorableColumnsUtil';
import * as ModalContainer from 'ui-library/ModalContainer';

import {configureMapColumnNamesModalPane} from './panes/MapColumnNamesModalPane';
import ShowErrorsModalPane from './panes/ShowErrorsModalPane';
import UploadSpreadsheetModalPane from './panes/UploadSpreadsheetModalPane';
import * as SpreadsheetBulkImportActions from './SpreadsheetBulkImportActions';
import {
  COLUMN_TYPE,
  IMPORT_TYPE,
  PaneKey,
  TRANSFER_COLUMN_TYPES,
  SPREADSHEET_BULK_IMPORT_KEY,
  Pane,
  SpreadsheetColumn,
} from './SpreadsheetBulkImportConstants';
import SpreadsheetBulkImportModalContainer from './SpreadsheetBulkImportModalContainer';
import * as TransferColumnsUtil from './TransferColumnsUtil';

interface Props {
  onRequestClose: () => void;
}

export default class BulkTransferStorablesFlow extends React.Component<Props> {
  static open(): void {
    ModalContainer.open(
      SPREADSHEET_BULK_IMPORT_KEY,
      <BulkTransferStorablesFlow onRequestClose={SpreadsheetBulkImportActions.closeModal} />
    );
  }

  _getPanes(): Array<Pane> {
    return [
      {
        paneKey: PaneKey.UPLOAD_SPREADSHEET,
        configuration: UploadSpreadsheetModalPane.configure({
          getExampleImageURL() {
            return '/static/img/spreadsheet-import-example-fill-plates.png';
          },
        }),
      },
      {
        paneKey: PaneKey.MAP_COLUMN_NAMES,
        configuration: configureMapColumnNamesModalPane({
          getValidColumnTypes() {
            return [...TRANSFER_COLUMN_TYPES, ...getSampleControlRolesColumns(), COLUMN_TYPE.IGNORE];
          },
          getRequiredColumnsError(columns: Array<SpreadsheetColumn>) {
            const inputColumnsError = TransferColumnsUtil.getInputColumnsError(columns, true);
            const outputColumnsError = TransferColumnsUtil.getOutputColumnsError(columns, true);
            const measurementColumnsError = TransferColumnsUtil.getMeasurementColumnsError(columns, true);
            return inputColumnsError || outputColumnsError || measurementColumnsError;
          },
          onValidateSpreadsheet: SpreadsheetBulkImportActions.validateSpreadsheetForTransferStorables,
        }),
      },
      {
        paneKey: PaneKey.SHOW_ERRORS,
        configuration: ShowErrorsModalPane.configure({
          enableReplaceLinkWithText: true,
          enableSkipErrors: true,
        }),
      },
    ];
  }

  render(): JSX.Element {
    return (
      <SpreadsheetBulkImportModalContainer
        importItemWord="container transfer"
        importType={IMPORT_TYPE.TRANSFER_STORABLES}
        onImportFromSpreadsheet={SpreadsheetBulkImportActions.transferStorablesFromSpreadsheetWithDataMods}
        onRequestClose={this.props.onRequestClose}
        panes={this._getPanes()}
        title="Import transfer data"
      />
    );
  }
}
